(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('.cart__qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const index = btn.dataset.qtyMinus !== undefined ? btn.dataset.index : btn.dataset.index;
      const inputs = document.querySelectorAll('.cart__qty-input');
      const input = inputs[btn.dataset.index];
      if (!input) return;
      const val = parseInt(input.value, 10) || 0;
      if (btn.dataset.qtyMinus !== undefined) {
        input.value = Math.max(0, val - 1);
      } else {
        input.value = val + 1;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const STORAGE_KEY = 'tp-popup-dismissed';
    const popup = document.getElementById('email-popup');
    const closeBtn = popup.querySelector('[data-popup-close]');

    if (!popup || localStorage.getItem(STORAGE_KEY)) return;

    const delay = parseInt(popup.dataset.delay, 10) || 4000;

    setTimeout(() => {
      popup.showModal();
      closeBtn.blur();
    }, delay);

    function dismiss() {
      popup.close();
      localStorage.setItem(STORAGE_KEY, '1');
    }

    closeBtn.addEventListener('click', dismiss);

    popup.addEventListener('click', (e) => {
      if (e.target === popup) dismiss();
    });

    // Submit form via fetch, show success state in place
    const form = document.getElementById('email-popup-form');
    const body = document.getElementById('email-popup-body');
    const success = document.getElementById('email-popup-success');

    if (form && body && success) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        try {
          await fetch(form.action || '/contact', {
            method: 'POST',
            body: new FormData(form),
          });
        } catch (_) {}
        body.setAttribute('hidden', '');
        success.removeAttribute('hidden');
        localStorage.setItem(STORAGE_KEY, '1');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('[data-header]');
    const hamburger = document.querySelector('.site-header__hamburger');
    const mobileNav = document.getElementById('mobile-nav');

    if (!header || !hamburger || !mobileNav) return;

    const closeBtn = mobileNav.querySelector('.mobile-nav__close');

    // Hide on scroll down, reveal on scroll up
    let lastScrollY = window.scrollY;
    const THRESHOLD = 80; // don't hide until scrolled past this many px

    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      const scrollingDown = currentScrollY > lastScrollY;

      if (currentScrollY <= THRESHOLD) {
        header.classList.remove('is-hidden', 'is-scrolled');
      } else if (scrollingDown) {
        header.classList.add('is-hidden', 'is-scrolled');
      } else {
        header.classList.remove('is-hidden');
        header.classList.add('is-scrolled');
      }

      lastScrollY = currentScrollY;
    }, { passive: true });

    // Mobile nav open
    hamburger.addEventListener('click', () => {
      mobileNav.removeAttribute('hidden');
      mobileNav.removeAttribute('aria-hidden');
      hamburger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    });

    // Mobile nav close
    closeBtn.addEventListener('click', () => {
      mobileNav.setAttribute('hidden', '');
      mobileNav.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-split-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.split-content__card');
    if (!cards.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    cards.forEach(card => {
      card.classList.add('will-animate');
      observer.observe(card);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const form = document.getElementById('product-form');
  if (form) {
    const input = form.querySelector('[data-qty-input]');
    form.querySelector('[data-qty-minus]').addEventListener('click', () => {
      const val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });
    form.querySelector('[data-qty-plus]').addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
